import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import lightGallery from 'lightgallery.js'

//Vue.use(lightGallery);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
  methods: {
  }
}).$mount('#app')

//lightGallery(document.getElementById('lightgallery'))